<template>
  <div id="cart">
    <van-nav-bar
      title="购物车"
      left-arrow
      class="my-nav"
      :fixed="true"
      :right-text="navBarRight"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div style="padding-top: 50px; padding-bottom: 50px; background: #fff">
      <div
        v-if="carts.length > 0"
        class="goods-list"
        v-for="cart in carts"
        :key="cart.id"
      >
        <div
          class="shop"
          style="
            border-bottom: 1px solid #eee;
            height: 25px;
            line-height: 25px;
            padding: 10px;
          "
        >
          <!--全选按钮-->
          <div @click="onCheckedShopCart(cart)">
            <van-checkbox
              style="float: left"
              :value="cart.checkedArray.length === cart.commodity.length"
            />
          </div>
          &nbsp;&nbsp;&nbsp;
          <van-icon name="shop-o" />
          {{ cart.name }}
        </div>
        <van-checkbox-group v-model="cart.checkedArray">
          <div
            v-for="item in cart.commodity"
            :key="item.skuId"
            style="position: relative"
          >
            <van-checkbox
              :key="item.skuId"
              :name="item.skuId"
              @click="onClickEveryShopCart(cart.id, item)"
              style="
                position: absolute;
                top: 50%;
                z-index: 1;
                margin-top: -10px;
                left: 10px;
              "
            />
            <van-card
              style="margin-left: 15px"
              :title="item.title"
              :desc="
                item.standard
                  .replace('null/', '')
                  .replace(/null/g, '')
                  .replace(/\//g, '') +
                '/' +
                item.color
              "
              :price="formatPrice(item.price)"
              :thumb="item.thumb"
              :thumb-link="'/#/goods/' + item.goodsId"
            >
              <div slot="footer" style="margin-top: -30px">
                <van-stepper
                  v-model="item.count"
                  :min="1"
                  :max="item.stepperLimit"
                  @change="onChangeBuyCount(item)"
                  :disabled="item.allBuy"
                />
              </div>
            </van-card>
          </div>
        </van-checkbox-group>
      </div>
      <div
        v-if="carts.length === 0"
        style="
          margin: 30% auto;
          text-align: center;
          color: #666;
        "
      >
        <img
          src="../../assets/images/empty.png"
          style="width: inherit; max-height: 200px"
        />
        <div style="padding: 10px 0">购物车中空空如也!</div>
        <van-button size="small" @click="$router.push('/classification')"
          >去逛逛</van-button
        >
      </div>
      <template v-if="carts.length > 0">
        <div v-if="showBuyBar">
          <van-submit-bar
            :price="totalPrice"
            :disabled="!(totalPrice&&!(bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0))"
            :button-text="submitBarText"
            @submit="onSubmit"
          >
            <!-- <div @click="onCheckedAll">
                            <van-checkbox :value="checkedAll" style="margin-left: 12px;">全选</van-checkbox>
                        </div> -->
          </van-submit-bar>
        </div>
        <div v-else>
          <van-submit-bar
            :disabled="!totalPrice"
            :button-text="deleteBarText"
            @submit="onDeleteSubmit"
          >
            <!-- <div @click="onCheckedAll" style="position: absolute; left: 0px">
              <van-checkbox :value="checkedAll" style="margin-left: 12px"
                >全选</van-checkbox
              >
            </div> -->
          </van-submit-bar>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import { listCurrentUserCart, save, deleteCartAll } from "../../api/carts";
import { Dialog, Toast } from "vant";
import bus from "../../bus";
import axios from "../../api/http";
import { API } from "../../api/const";

export default {
  data() {
    return {
      navBarRight: "编辑",
      showBuyBar: true,
      checkedAll: false,
      bus,
      carts: [
        /*{
          "id": 11,
          "name": "山东金怡华通讯",
          "commodity": [
            {
              checked: false,
              "title": "华为畅享8",
              "standard": "4+64/全网通",
              "color": "金色",
              "count": 4,
              "price": 1085,
              "thumb": "http://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/goods_f4c9a76aee24e8176139b51fa2d91f6a.jpg",
              "skuCode": "2611200778",
              "shopId": 11,
              "skuId": 3673
            }
          ]
        }*/
      ],
    };
  },
  computed: {
    submitBarText() {
      let list = this.listCheckedSku();
      const count = list.reduce((total, item) => total + item.count, 0);
      return "结算" + (count ? `(${count})` : "");
    },
    deleteBarText() {
      let list = this.listCheckedSku();
      const count = list.reduce((total, item) => total + item.count, 0);
      return "删除" + (count ? `(${count})` : "");
    },
    totalPrice() {
      let list = this.listCheckedSku();
      return (
        list.reduce((total, item) => total + item.price * item.count, 0) * 100
      );
    },
  },
  watch: {
    carts: {
      handler(newValue) {
        const isCheckedAll = () => {
          for (let cart of newValue) {
            if (cart.checkedArray.length !== cart.commodity.length) {
              return false;
            }
          }
          return true;
        };
        if (isCheckedAll()) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    formatPrice(price) {
      return price.toFixed(2);
    },
    onSubmit() {
      let cartsCopy = JSON.parse(JSON.stringify(this.carts));
      let checkedSkuIdSet = new Set();
      this.carts.forEach((cart) => {
        cart.checkedArray.forEach((skuId) => checkedSkuIdSet.add(skuId));
      });
      cartsCopy = cartsCopy
        .map((cart) => {
          let commodity = cart.commodity;
          cart.commodity = commodity.filter((item) =>
            checkedSkuIdSet.has(item.skuId)
          );
          return cart;
        })
        .filter((cart) => cart.commodity.length > 0);
      axios
        .post(API + "/v2/goods/checkStock", cartsCopy)
        .then((res) => {
          bus.state.buyList = cartsCopy;
          bus.state.cartSubmitFlag = true;
          this.$router.push("/order-submit");
        })
        .catch((error) => {
          Toast(error + " 库存不足");
        });
    },
    onDeleteSubmit() {
      Dialog.confirm({
        message: "是否确认删除?",
      })
        .then(() => {
          deleteCartAll(
            this.listCheckedSku().map((item) => ({
              batchId: item.batchId
            })),
            (_) => {
              Toast("删除成功");
              listCurrentUserCart((data) => {
                this.carts = data;
              });
            }
          );
        })
        .catch(() => {
          Toast("取消成功");
        });
    },
    listCheckedSku() {
      let list = [];
      let checkedSkuIdSet = new Set();
      this.carts.forEach((cart) => {
        cart.checkedArray.forEach((skuId) => checkedSkuIdSet.add(skuId));
        cart.commodity.forEach((item) => list.push(item));
      });
      return list.filter((item) => checkedSkuIdSet.has(item.skuId));
    },
    onClickLeft() {
      this.$router.back(-1);
    },
    onClickRight() {
      this.showBuyBar = !this.showBuyBar;
      this.navBarRight = this.showBuyBar ? "编辑" : "完成";
    },
    onCheckedAll() {
      this.checkedAll = !this.checkedAll;
      if (this.checkedAll) {
        this.carts.forEach((cart) => {
          cart.checked = false;
          this.onCheckedShopCart(cart);
        });
      } else {
        this.carts.forEach((cart) => {
          cart.checked = true;
          this.onCheckedShopCart(cart);
        });
      }
    },
    onCheckedShopCart(cart) {
      // 获取当前全选按钮状态
      cart.checked = !cart.checked;
      // 如果当前是全选,把此店铺下商品都加入已选
      if (cart.checked) {
        this.carts.forEach((car) => {
          car.checkedArray = [];
        });
        cart.commodity.forEach((item) => {
          cart.checkedArray.push(item.skuId);
          item.checked = true;
        });
        // 当前是取消全选，把此店铺下已选商品清空
      } else {
        cart.checkedArray = [];
        cart.commodity.forEach((item) => {
          item.checked = false;
        });
      }
    },
    onClickEveryShopCart(shopId, item) {
      if (item.checked === true) {
        item.checked = false;
      }else {
        item.checked = true;
      }

      let currShopCart = this.carts.filter(cart => {
        return cart.id === shopId;
      })[0];

      currShopCart.checkedArray = [];

      currShopCart.commodity.forEach(commodity => {
        if (commodity.batchId === item.batchId) {
          commodity.checked = item.checked;
        }
        if (commodity.checked) {
          currShopCart.checkedArray.push(commodity.skuId);
        }
      })

      // 后台校验sku库存
      // axios.get(API + `/v2/goods/currSkuStock?shopId=${shopId}&skuCode=${item.skuCode}`).then(res => {
      //     if(res.data.stockQty < item.count) {
              // this.carts = this.carts.map(cart => {
              //     if(cart.id === shopId) {
              //         cart.checkedArray = cart.checkedArray.filter(checked => {
              //             return checked !== item.skuId;
              //         })
              //     }
              //     return cart;
              // })
      //         Toast('库存不足')
      //     }
      // })
    },
    onChangeBuyCount(sku) {
      let cart = {
        shopId: sku.shopId,
        skuCode: sku.skuCode,
        number: sku.count,
        skuId: sku.skuId,
      };
      save(cart, (d) => {});
    },
  },
  mounted() {
    listCurrentUserCart((data) => {
      // 全选
      // data.forEach(item => {
      //     item.commodity.forEach(sku => {
      //         item.checkedArray.push(sku.skuId)
      //     })
      // })
      this.carts = data;
    });
  },
};
</script>

<style lang="less" scoped>
.goods-list {
  /*border-bottom: 5px solid #fafafa;*/
  /* box-shadow: 5px 5px 5px #ddd;*/
  box-shadow: 2px 2px 1px #f2f2f2;
}

.card-goods {
  padding: 10px;
  color: #666;
  font-size: 17px;
  /*background-color: #fff;*/

  &__item {
    position: relative;
    float: left;
    align-items: center;
    background-color: #fafafa;
    margin-top: 40px;

    .van-checkbox__label {
      width: 100%;
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .van-card__price {
      color: #f44;
    }
  }
}

.van-submit-bar,
.not-show-bar {
  left: 0;
  /*bottom: 50px;*/
  width: 100%;
  z-index: 100;
  position: fixed;
}
</style>
